import React from "react";
import {connect} from "react-redux";
import {CheckboxTable} from "../../view/CheckboxTable";
import {debug} from "../../utils";
import VulscanTableRow from "./VulscanTableRow";


function VulscanTable({scanList}) {

    //TODO implement
    const headers = [
        {name: 'TARGET', onClick: () => {}},
        {name: 'SCAN TYPE', onClick: () => {}},
        {name: 'STATUS', onClick: () => {}},
        {name: 'SCHEDULED', onClick: () => {}},
        {name: 'LAST RUN'},

    ]

    return (
        <>
            {scanList.length > 0 ?
            <CheckboxTable headers={headers} elements={scanList}>
                {scanList.map((scan, index) => <VulscanTableRow key={index} data={scan} index={index}/>)}
            </CheckboxTable>
            :
            <div className="network-scan-empty-v2">No Nmap scans found</div>}
        </>
    )

}


function mapStateToProps(state) {
    debug("VulscanTable mapStateToProps", state);
    const vulscanPage = state.vulscanPage;
    return {
        scanList: vulscanPage.scanList || []
    };
}


export default connect(mapStateToProps)(VulscanTable);
